import { defineAgenda, param } from '@/shared/navigation/core';
import { SERIE_TAB_KEYS } from '../internal/serieLayers';

/**
 * Agenda detailu termínového seriálu. Otevírá se výběrem uzlu seriálu ve stromu (potřebuje productId i serieId,
 * aby odpovídala backendovému kontraktu `/products/{productId}/series/{serieId}`).
 */
export const serieDetailAgenda = defineAgenda({
  id: 'app.venua-planner.serie-detail',
  path: 'app/venua-planner/serie-detail',
  open: {
    productId: param.uuid(),
    serieId: param.uuid(),
    // Volitelný intent: po otevření rovnou zobrazit dialog „Přidat termíny" (z „+" u seriálu ve stromu
    // plánovací agendy). Bez něj se detail otevře běžně (výběrem řádku / tužkou v kalendáři).
    addTerms: param.boolean().optional(),
  },
  state: {
    // Zvolená záložka (vrstva dat) — stejná sada jako u detailu termínu, viz `SERIE_TAB_KEYS`.
    // V URL, aby reload zůstal na stejné záložce a aby ji další detail mohl převzít.
    tab: param.enum(SERIE_TAB_KEYS).optional(),
    // Rozbalený termín v tabulce na záložce Yield Management. V URL, aby ho obnovil reload
    // i proklik z treeview (klik na termín při této záložce otevře seriál s rozbaleným termínem).
    calcTermId: param.uuid().optional(),
  },
  title: 'Detail seriálu',
  icon: 'chain',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
